module.exports = __webpack_public_path__ + "img/field-level-endzone-gal-1.e2141871.jpg";